import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AssetsList from "../3DModel/AssetsList";
import InfiniteScroll from "react-infinite-scroll-component";
import { useParams } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import { SearchContext } from "../../store/context/searchContext";
import apiClient from "../../apiClient";
import { CATEGORY_3D_ASSET_LIST } from "../../apiClient/apiEndPoints";
import { debounce } from "../../utils/common";
import NoModel from "../../Assets/Images/moModels.png";

const limit = 50;

const AssetsDashboard = () => {
  const { search } = useContext(SearchContext);
  const configData = useSelector((state) => state.configSlice);
  const params = useParams();
  const { id } = params;
  const [preCategoryId, setPreCategoryId] = useState(null);
  const [page, setPage] = useState(1);
  const [platform, setPlatform] = useState("universal");
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(true);
  const [assetList, setAssetList] = useState([]);

  const getAllCategoryAssets = async (pageId) => {
    setHasMore(true);
    try {
      let data = await apiClient.get(`${configData.config.UNO_URL}${CATEGORY_3D_ASSET_LIST}/${platform}/${id}`, {
        params: {
          search,
          limit,
          page: pageId || page,
        },
      });

      let newAssets = data.list;

      if (id == preCategoryId) {
        const updatedList = search.length > 0 ? newAssets : [...assetList, ...newAssets];
        setAssetList(updatedList);
      } else {
        setAssetList(newAssets);
      }
      setPreCategoryId(id);
      setHasMore(newAssets.length === limit);
      setPage((pre) => (newAssets.length === limit ? pre + 1 : 1));
    } catch (error) {
      console.error(error);
      setHasMore(false);
    } finally {
      setLoading(false);
    }
  };

  const loadMore = () => {
    if (hasMore) {
      getAllCategoryAssets();
    }
  };

  const debouncedFetch = debounce(() => {
    setHasMore(true);
    setPage(1);
    getAllCategoryAssets(1);
  }, 250);

  useEffect(() => {
    debouncedFetch();
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
    setLoading(true);
  }, [search, id]);

  return (
    <>
      <div className="asset-dash">
        <InfiniteScroll
          scrollThreshold={0.8}
          dataLength={assetList.length}
          next={loadMore}
          hasMore={hasMore}
          loader={
            <div className="asset-list">
              {Array.from({ length: 10 }).map((_, index) => (
                <div className="asset-item" key={index}>
                  <div className="asset-thumb">{""}</div>
                  <div className="asset-info">
                    <h6>
                      <Skeleton width="100%" height="100%" />
                    </h6>
                    <p>
                      <Skeleton width="90%" height="65%" />
                    </p>
                    <div className="d-flex align-item-center justify-content-start gap-2">
                      <Skeleton width="4rem" height="1.1rem" />
                      <Skeleton width="4rem" height="1.1rem" />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          }
        >
          {loading ? (
            <div className="asset-list">
              {Array.from({ length: 5 }).map((_, index) => (
                <div className="asset-item" key={index}>
                  <div className="asset-thumb">{""}</div>
                  <div className="asset-info">
                    <h6>
                      <Skeleton width="100%" height="100%" />
                    </h6>
                    <p>
                      <Skeleton width="90%" height="65%" />
                    </p>
                    <div className="d-flex align-item-center justify-content-start gap-2">
                      <Skeleton width="4rem" height="1.1rem" />
                      <Skeleton width="4rem" height="1.1rem" />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <AssetsList list={assetList} />
          )}
        </InfiniteScroll>
      </div>
    </>
  );
};

export default AssetsDashboard;
